const STORAGE_KEY = 'dt_chunk_settings'

export const DEFAULT_CHUNK_SETTINGS = {
  n: 40,
  quotas: {
    journal:  { mode: 'min', value: 5 },
    personal: { mode: 'min', value: 5 },
    resume:   { mode: '=',   value: 2 },
    threads:  { mode: 'min', value: 3 },
  },
  fast_mode: false,
}

export function getAllSettings() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') }
  catch { return {} }
}

export function getSettingsForUser(userId) {
  const all = getAllSettings()
  return all[userId] || all['default'] || DEFAULT_CHUNK_SETTINGS
}

export function saveSettingsLocally(userId, settings) {
  const all = getAllSettings()
  all[userId] = settings
  localStorage.setItem(STORAGE_KEY, JSON.stringify(all))
}

// Computed: how many chunks go to group (remainder)
export function groupRemainder(settings) {
  const { n, quotas } = settings
  const used = Object.values(quotas || {}).reduce((s, q) => {
    if (q.mode === 'max') return s  // max doesn't consume guaranteed budget
    return s + (q.value || 0)
  }, 0)
  return Math.max(0, n - used)
}
